// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hxgh-list-div{padding:0 16px}.hxgh-list-div .line-list-div{height:750px;max-height:750px;overflow-y:auto}.hxgh-list-div .el-collapse .el-collapse-item{background:#dcdfe6}.hxgh-list-div .el-collapse .el-collapse-item .el-collapse-item__header{color:#097cf5;padding:0 10px}.hxgh-list-div .item-moni{display:flex;justify-content:center;align-items:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
